import Base from './Base';

const ENTITY = 'login';
export const REDUCER_NAME = ENTITY;

const initialState = { isFetching: true, isSingleObject: true, values: {} };
const news = new Base(ENTITY, initialState);

export const reducer = news.reducer.bind(news);
news.getAsync.bind(news);
news.putAsync.bind(news);
news.postAsync.bind(news);

export const get = () => {
  return news.getAsync(`${ENTITY}`);
};

export const post = (data) => {
  return news.postAsync(`${ENTITY}`, data);
};

export const logout = () => {
  return news.postAsync(`logout`, {});
};

export const put = (id, data) => {
  return news.putAsync(`${ENTITY}/${id}`, data);
};

export const del = (id, data) => {
  return news.deleteAsync(`${ENTITY}/${id}`, data);
};



// WEBPACK FOOTER //
// ./src/redux/modules/login.js